import React from 'react';
import Loadable from 'react-loadable';
import { Spin } from 'antd';

const load = (loader: any) => {
  return Loadable({
    loader,
    loading() {
      return <Spin tip="Loading..." />;
    }
  });
};

// 首页
// const Home = load(() => import('./src/Home/index'));
// 考试中心
const TestCenter = load(() => import('./src/Test/index'));
const TestManage = load(() => import('./src/Test/manage')); // 考试管理
const TestManageDetail = load(() => import('./src/Test/manage/detail')); // 考试管理详情
const TestCertificateManage = load(() => import('./src/Test/certmanage')); // 证书管理
const TestCertificate = load(() => import('./src/Test/certificate')); // 证书模板

// 考试管理
const TestManageIndex = load(() => import('./src/TestManage'));
const TestCreate = load(() => import('./src/TestManage/CreateTest'));
const TestList = load(() => import('./src/TestManage/TestList'));
const TestUpdate = load(() => import('./src/TestManage/TestList/TestUpdate'));
const TestInfo = load(() => import('./src/TestManage/TestList/TestInfo'));
const TestEnvList = load(() => import('./src/TestManage/TestList/TestEnvList'));
const TestExpList = load(() => import('./src/TestManage/TestList/TestExpList'));
const TestNoticeList = load(() => import('./src/TestManage/TestList/TestNoticeList'));
const QuestionCreate = load(() => import('./src/TestManage/CreateQuestion'));
const PaperList = load(() => import('./src/TestManage/PaperList'));
const PaperUpdate = load(() => import('./src/TestManage/PaperList/PaperUpdate'));
// const ScoreInquiry = load(() => import('./src/TestManage/ScoreInquiry'));
const ScoreInquiryInfo = load(() => import('./src/TestManage/ScoreInquiry/TestInfo'));
const QuestionList = load(() => import('./src/TestManage/QuestionList'));
const QuestionCertificate = load(() => import('./src/TestManage/Certificate'));
const QuestionCertificateList = load(() => import('./src/TestManage/CertificateList/index'));
// 活动中心
const ActivityCenter = load(() => import('./src/Activity/index'));
const ActivityManage = load(() => import('./src/Activity/manage')); // 活动管理
// const ActivityPersonnel = load(() => import('./src/Activity/personnel')); // 人员管理

// 课程中心
const CourseManage = load(() => import('./src/Course/index'));
const MyCourse = load(() => import('./src/Course/MyCourse/index')); // 我的课程
const CourseTypes = load(() => import('./src/Course/CourseTypes/index')); // 课程分类
const Lecturer = load(() => import('./src/Course/Lecturer/index')); // 讲师管理
const Banner = load(() => import('./src/Course/Banner/index')); // 轮播管理
const Census = load(() => import('./src/Course/Census/index')); // 课程统计
const CourseDetail = load(() => import('./src/Course/Detail/index')); // 课程详情，但是菜单上并不展示
// 用户中心
const UserCenter = load(() => import('./src/User/index'));
// 知识库
const Knowledge = load(() => import('./src/Knowledge'));

const Routes = [
  // {
  //   title: "首页",
  //   key: "/admin/home",
  //   disbaled: false,
  //   exact: false,
  //   icon: "user",
  //   component: Home,
  //   child: []
  // },
  {
    title: "课程中心",
    key: "/admin/course",
    disbaled: false,
    exact: false,
    icon: "user",
    component: CourseManage,
    child: [
      {
        title: "课程管理",
        key: "/admin/course/my",
        disbaled: false,
        exact: false,
        icon: "home",
        component: MyCourse
      }, {
        title: "分类管理",
        key: "/admin/course/types",
        disbaled: false,
        exact: false,
        icon: "home",
        component: CourseTypes
      }, {
        title: "讲师管理",
        key: "/admin/course/lecturer",
        disbaled: false,
        exact: false,
        icon: "home",
        component: Lecturer
      }, {
        title: "轮播管理",
        key: "/admin/course/banner",
        disbaled: false,
        exact: false,
        icon: "home",
        component: Banner
      },
      {
        title: "课程统计",
        key: "/admin/course/census",
        disbaled: false,
        exact: false,
        icon: "home",
        component: Census
      },
      {
        title: "课程详情",
        key: "/admin/course/detail",
        disbaled: true,
        exact: false,
        icon: "home",
        component: CourseDetail
      },
    ]
  },
  {
    title: "考试管理",
    key: "/admin/manage",
    disbaled: false,
    exact: false,
    icon: "user",
    component: TestManageIndex,
    child: [
      {
        title: "创建考试",
        key: "/admin/manage/test_add",
        disbaled: false,
        exact: true,
        icon: "home",
        component: TestCreate
      },
      {
        title: "创建考试2",
        key: "/admin/manage/test_config",
        disbaled: true,
        exact: true,
        icon: "home",
        component: TestCreate
      },
      {
        title: "创建考试3",
        key: "/admin/manage/test_create",
        disbaled: true,
        exact: true,
        icon: "home",
        component: TestCreate
      },
      {
        title: "创建题目",
        key: "/admin/manage/create_question",
        disbaled: false,
        exact: true,
        icon: "home",
        component: QuestionCreate
      },
      {
        title: "考试列表",
        key: "/admin/manage/test_list",
        disbaled: false,
        exact: true,
        icon: "home",
        component: TestList
      },
      {
        title: "编辑考试",
        key: "/admin/manage/test_list/update/:id",
        disbaled: true,
        exact: true,
        icon: "home",
        component: TestUpdate
      },
      {
        title: "考试详情",
        key: "/admin/manage/test_info/:id",
        disbaled: true,
        exact: true,
        icon: "home",
        component: TestInfo
      },
      {
        title: "考试环境反馈",
        key: "/admin/manage/test_evn_list/:id",
        disbaled: true,
        exact: true,
        icon: "home",
        component: TestEnvList
      },
      {
        title: "考试评价",
        key: "/admin/manage/test_exp_list/:id",
        disbaled: true,
        exact: true,
        icon: "home",
        component: TestExpList
      },
      {
        title: "邮件通知列表",
        key: "/admin/manage/test_notice_list/:id",
        disbaled: true,
        exact: true,
        icon: "home",
        component: TestNoticeList
      },
      {
        title: "试卷库",
        key: "/admin/manage/paper_list",
        disbaled: false,
        exact: true,
        icon: "home",
        component: PaperList
      },
      {
        title: "编辑试卷",
        key: "/admin/manage/paper_list/update/:status/:id",
        disbaled: true,
        exact: true,
        icon: "home",
        component: PaperUpdate
      },
      // {
      //   title: "成绩批改查阅",
      //   key: "/admin/manage/score_inquiry",
      //   disbaled: false,
      //   exact: true,
      //   icon: "home",
      //   component: ScoreInquiry
      // },
      {
        title: "考试管理详情",
        key: "/admin/manage/score_inquiry/:id",
        disbaled: true,
        exact: false,
        icon: "home",
        component: ScoreInquiryInfo
      },
      {
        title: "题库",
        key: "/admin/manage/question_list",
        disbaled: false,
        exact: true,
        icon: "home",
        component: QuestionList
      },
      {
        title: "证书模板",
        key: "/admin/manage/certificate_temp",
        disbaled: false,
        exact: true,
        icon: "home",
        component: QuestionCertificate
      },
      {
        title: "证书列表",
        key: "/admin/manage/certificate_list",
        disbaled: false,
        exact: true,
        icon: "home",
        component: QuestionCertificateList
      },
    ]
  },
  // {
  //   title: "考试中心",
  //   key: "/admin/test",
  //   disbaled: false,
  //   exact: false,
  //   icon: "user",
  //   component: TestCenter,
  //   child: [
  //     {
  //       title: "考试管理",
  //       key: "/admin/test/manage",
  //       disbaled: false,
  //       exact: true,
  //       icon: "home",
  //       component: TestManage
  //     },
  //     {
  //       title: "证书管理",
  //       key: "/admin/test/certmanage",
  //       disbaled: false,
  //       exact: false,
  //       icon: "home",
  //       component: TestCertificateManage
  //     },
  //     {
  //       title: "证书模板",
  //       key: "/admin/test/certificate",
  //       disbaled: false,
  //       exact: false,
  //       icon: "home",
  //       component: TestCertificate
  //     },
  //     // {
  //     //   title: "人员管理",
  //     //   key: "/admin/test/personnel",
  //     //   disbaled: false,
  //     //   exact: false,
  //     //   icon: "home",
  //     //   component: TestPersonnel
  //     // },
  //     {
  //       title: "考试管理详情",
  //       key: "/admin/test/manage/:id",
  //       disbaled: true,
  //       exact: false,
  //       icon: "home",
  //       component: TestManageDetail
  //     },
  //   ]
  // }, 
  // {
  //   title: "活动中心",
  //   key: "/admin/activity",
  //   disbaled: false,
  //   exact: false,
  //   icon: "home",
  //   component: ActivityCenter,
  //   child: [
  //     {
  //       title: "活动管理",
  //       key: "/admin/activity/manage",
  //       disbaled: false,
  //       exact: false,
  //       icon: "home",
  //       component: ActivityManage
  //     },
  //     // {
  //     //   title: "人员管理",
  //     //   key: "/admin/activity/personnel",
  //     //   disbaled: false,
  //     //   exact: false,
  //     //   icon: "home",
  //     //   component: ActivityPersonnel
  //     // }
  //   ]
  // }, 
  {
    title: "用户中心",
    key: "/admin/user",
    disbaled: false,
    exact: false,
    icon: "home",
    component: UserCenter,
    child: [
      {
        title: "用户管理",
        key: "/admin/user/manage",
        disbaled: false,
        exact: false,
        icon: "home",
        component: UserCenter
      }
    ]
  },
  {
    title: "知识库",
    key: "/admin/knowledge",
    disabled: false,
    exact: false,
    icon: "home",
    component: Knowledge,
    child: [
      {
        title: "文档管理",
        key: "/admin/knowledge/documents",
        disbaled: false,
        exact: false,
        icon: "home",
        component: Knowledge
      }
    ]
  }
]

export default Routes;
